/** Floor plans grouped by their venue. Venue ids are uuids, so keys stay strings. */
export function groupFloorPlansByVenue<T extends { venue_id: string }>(floorPlans: T[]): Record<string, T[]> {
  return floorPlans.reduce<Record<string, T[]>>((acc, fp) => ({ ...acc, [fp.venue_id]: [...(acc[fp.venue_id] || []), fp] }), {});
}

export function venueNameFor(venues: Array<{ id: string; name: string }>, venueId: string): string {
  return venues.find(v => v.id === venueId)?.name ?? `Venue ${venueId}`;
}
